import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary } from './ErrorBoundary';
import { logClientError } from './firebase';
import { captureReferralFromLocation } from './referralTracking';
import reportWebVitals from './reportWebVitals';

// Step 18 of the affiliate roadmap — capture ?ref=<teacherUid> into a cookie on first arrival,
// before anything else runs. Plain synchronous side effect, not a React concern: it doesn't
// need to be inside a component (nothing renders differently because of it), and running it
// here guarantees it happens exactly once per real page load, before React or Firebase Auth
// state exist yet. See referralTracking.js for the full design (cookie vs localStorage,
// first-touch semantics, why validation is deliberately loose here).
captureReferralFromLocation();

// Catches errors ErrorBoundary never sees: thrown outside any render/effect call stack
// (e.g. a rejected promise from an async event handler like handleLessonComplete), or
// before the tree has even mounted. Best-effort — see logClientError.
window.addEventListener('error', (e) => {
  logClientError({ message: e.message, stack: e.error?.stack, source: 'window.onerror' });
});
window.addEventListener('unhandledrejection', (e) => {
  const reason = e.reason;
  logClientError({
    message: reason?.message ?? String(reason),
    stack: reason?.stack,
    source: 'unhandledrejection',
  });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
